"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceIdT = exports.DeviceId = void 0;
/**
 * A unique ID for the device. IDs are not guaranteed to be the same after
 * the connection is terminated.
 */
class DeviceId {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    id() {
        return this.bb.readUint8(this.bb_pos);
    }
    static sizeOf() {
        return 1;
    }
    static createDeviceId(builder, id) {
        builder.prep(1, 1);
        builder.writeInt8(id);
        return builder.offset();
    }
    unpack() {
        return new DeviceIdT(this.id());
    }
    unpackTo(_o) {
        _o.id = this.id();
    }
}
exports.DeviceId = DeviceId;
class DeviceIdT {
    constructor(id = 0) {
        this.id = id;
    }
    pack(builder) {
        return DeviceId.createDeviceId(builder, this.id);
    }
}
exports.DeviceIdT = DeviceIdT;
